import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerPasswordRulesBoxResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle(
    'de',
    'record-it-components',
    {
      misc: {
        PasswordRulesBox: {
          requiredLength:
            'Passwort muss mindestens {{requiredLength}} Zeichen lang sein.'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
